// extracted by mini-css-extract-plugin
export default {"layout":"PageLayout_layout__39kjl","content":"PageLayout_content__HvFSM"};